import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OperatorShifts } from 'app/models/operator-shifts.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OperatorshiftsService {
  constructor(private http: HttpClient) {}

  getTurnosOperadores(): Observable<OperatorShifts | any> {
    return this.http.get(environment.apiUrl + 'operator-shift');
  }

  getTurnoOperador(id: number) {
    return this.http.get(environment.apiUrl + 'operator-shift/' + id);
  }

  updateTurnoOperador(id: number, value) {
    return this.http.patch(environment.apiUrl + 'operator-shift/' + id, value);
  }

  saveTurnoOperador(value: OperatorShifts) {
    return this.http.post(environment.apiUrl + 'operator-shift', value);
  }

  deleteTurnoOperador(id: number) {
    return this.http.delete(environment.apiUrl + 'operator-shift/' + id);
  }
}
